export const formatDate = (dateString) => {
  if (!dateString) return "/";
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(dateString).toLocaleDateString('en-CA', options);
};

export const developmentData = {
  "firstName": "John",
  "lastName": "Doe",
  "accounts": [
    {
      "id": "qwr6MeZ7waAr",
      "email": "info@johndoe.com",
      "first_name": "John",
      "last_name": "Doe",
      "roles": [],
      "subscription": "2025-07-03T00:00:00.000Z",
      "devices": [
        {
          "id": "jgKWjpYA8v",
          "device": "hyper",
          "serial": 30009,
          "key": "6EAQ-QOL-VHW-GHC",
          "catalog_navigator_version": "1.0.0",
          "settings": {
            "navigator_version": "0.9.0",
          },
          "created_at": "2020-09-24T15:27:02.000Z",
          "updated_at": "2020-09-24T16:21:43.000Z"
        },
        {
          "id": "PEA4b8ZBqa",
          "device": "oudieNG",
          "device_model": "oudieNGlidingIgc",
          "serial": 0,
          "key": "15-0022",
          "created_at": "2022-01-17T07:27:59.000Z",
          "updated_at": "2024-03-06T14:16:28.000Z"
        }
      ],
      "sims": [
        {
          "iccid": "8931080019073052266",
          "serial": "20-0492",
          "expires_at": "2026-11-30T00:00:00.000Z",
          "is_trial": false,
          "is_expired": false,
          "grace_ends_at": "2026-12-07T00:00:00.000Z",
          "subscription_status": "active"
        },
        {
          "iccid": "8931080019073052189",
          "serial": "20-0492",
          "expires_at": "2025-08-14T00:00:00.000Z",
          "is_trial": true,
          "is_expired": true
        }
      ],
      "has_glider_in_hangar": false,
      "has_paraglider_in_hangar": true,
      "has_hangglider_in_hangar": false,
      "created_at": "2016-11-07T17:18:01.000Z",
      "updated_at": "2021-11-30T15:57:54.000Z"
    },
    {
      "id": "qwr6MeZ7waAr",
      "email": "info@johndoe.com",
      "first_name": "John",
      "last_name": "Doe",
      "roles": [],
      "created_at": "2016-11-07T17:18:01.000Z",
      "updated_at": "2021-11-30T15:57:54.000Z"
    },
    {
      "id": "qwr6MeZ7waAr",
      "email": "info@johndoe.com",
      "first_name": "John",
      "last_name": "Doe",
      "roles": [],
      "created_at": "2016-11-07T17:18:01.000Z",
      "updated_at": "2021-11-30T15:57:54.000Z"
    }
  ]
};